import { createIcon } from './createIcon'

export const SaveIcon = createIcon({
  displayName: 'SaveIcon',
  viewBox: '2 2 18 18',
  path: [
    <path
      d="M15.5833 2.75H4.58333C3.56583 2.75 2.75 3.575 2.75 4.58333V17.4167C2.75 18.425 3.56583 19.25 4.58333 19.25H17.4167C18.425 19.25 19.25 18.425 19.25 17.4167V6.41667L15.5833 2.75ZM17.4167 17.4167H4.58333V4.58333H14.8225L17.4167 7.1775V17.4167ZM11 11C9.47833 11 8.25 12.2283 8.25 13.75C8.25 15.2717 9.47833 16.5 11 16.5C12.5217 16.5 13.75 15.2717 13.75 13.75C13.75 12.2283 12.5217 11 11 11ZM5.5 5.5H13.75V9.16667H5.5V5.5Z"
      fill="currentColor"
    />,
  ],
})
